import MessagingRoutesBaseHandler from './base-handler.js';

export default class MessagingRoutesPreviousMembersHandler extends MessagingRoutesBaseHandler {
  get conversation() {
    return this.options.parentHandler.conversation;
  }

  get detailsHandler() {
    return this.options.parentHandler;
  }

  get members() {
    return this.detailsHandler.previousMembers;
  }

  canNavigateToClientProfile(member) {
    return this.detailsHandler.canNavigateToClientProfile(member);
  }

  get navigateToClientProfile() {
    return this.detailsHandler.navigateToClientProfile;
  }
}
